import { Tabs, Tag } from 'antd'
import { useSelector } from 'react-redux'
import { CommentOutlined } from '@ant-design/icons'
import { useHistory, useLocation } from 'react-router-dom'

const TabFilter = ({ filterName, tabs }) => {
  const history = useHistory()
  const location = useLocation()
  const searchParams = new URLSearchParams(history.location.search)

  const chatCount = useSelector((state) => state.theme.chatCount)
  const isChatPage = location.pathname.split('/')[3] === 'Messages'
  const activeKey = searchParams.get(filterName) || 'Online'

  return (
    <div className='position-relative'>
      <Tabs
        className='mt-3'
        items={tabs}
        activeKey={activeKey}
        onTabClick={(key) => {
          history.push(`${history.location.pathname}?${filterName}=${key}`)
        }}
      />
      {isChatPage && chatCount ? (
        <Tag
          icon={<CommentOutlined />}
          color='default'
          className='text-dimmed fw-semibold position-absolute bottom-0 end-0 mx-3 my-2'
        >
          Conversazioni totali: {chatCount}
        </Tag>
      ) : null}
    </div>
  )
}

export default TabFilter
